import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {

    if(sessionStorage.getItem("log")=="log")
    {
      sessionStorage.setItem("log","logupdated");
      location.reload();
    }
  }

}
